// third-party
import { Trans } from 'react-i18next';

// assets
import { IconScan } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconScan
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface SystemMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children?: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}
const order: SystemMenuProps = {
    id: 'orders',
    title: <Trans i18nKey="orders" id="orders" />,
    type: 'group',
    children: [
        {
            id: 'scan-order-success',
            title: <Trans i18nKey="Scan order" id="Scan order" />,
            type: 'item',
            url: '/scan-order-success',
            icon: icons.IconScan,
            breadcrumbs: false
        },
        {
            id: 'my-orders',
            title: <Trans i18nKey="My orders" id="my-orders" />,
            type: 'item',
            url: '/my-orders',
            icon: icons.IconScan,
            breadcrumbs: false
        },
    ]
};

export default order;
